import { render } from "./AuditLog.vue?vue&type=template&id=38a783f4&ts=true"
import script from "./AuditLog.vue?vue&type=script&lang=ts"
export * from "./AuditLog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__